/* eslint-disable radix */
'use strict';
var Glide = require('@glidejs/glide/dist/glide.js');

const createSlideLength = function createSlideLength(glide, Components, Events) {
    return {
        mount() {
            Events.emit('slider.length', Components.Sizes.length);
        }
    };
};

/**
 * Sets the aria-live property on current slide
 * @param {*} glide - instance of glidejs
 *
 */
const setAriaAttributes = (glide) => {
    glide.on('run', () => {
        const thisGlideSlide = glide._c.Html.slides[glide.index]; // eslint-disable-line
        glide._c.Html.slides.forEach((slide) => { // eslint-disable-line
            slide.setAttribute('aria-live', 'off');
        });
        thisGlideSlide.setAttribute('aria-live', 'polite');
    });
};

/**
 * Display the returned message.
 * @param {string} galleryScroller - data returned from the server's ajax call
 * @param {string} galleryItemSize - button that was clicked for contact us sign-up
 */
function scrollToNextPage(galleryScroller, galleryItemSize) {
    var items = galleryScroller.children;
    if (galleryScroller.scrollTop >= galleryItemSize) {
        galleryScroller.append(items[0]);
    }
    galleryScroller.scrollBy(0, galleryItemSize);
}

/**
 * Display the returned message.
 * @param {string} galleryScroller - data returned from the server's ajax call
 * @param {string} galleryItemSize - button that was clicked for contact us sign-up
 */
function scrollToPrevPage(galleryScroller, galleryItemSize) {
    var items = galleryScroller.children;
    if (galleryScroller.scrollTop <= galleryItemSize) {
        galleryScroller.prepend(items[items.length - 1]);
    }
    galleryScroller.scrollBy(0, -galleryItemSize);
}

/**
 * Display the returned message.
 * @param {string} el - data returned from the server's ajax call
 * @param {string} linkCarousel - data returned from the server's ajax call
 * @param {string} activeSlide - data returned from the server's ajax call
 */
function setActive(el, linkCarousel, activeSlide) {
    var scrollTop = el.scrollTop;
    var slides = el.children;
    var slideHeight = 0;
    for (var j = 0; j < slides.length; j++) {
        slides[j].classList.remove('active');
        slides[j].setAttribute('aria-live', 'off');
    }
    for (var i = 0; i < slides.length; i++) {
        slideHeight = slides[i].clientHeight;
        if (activeSlide && !slides[activeSlide].classList.contains('active')) {
            slides[activeSlide].classList.add('active');
            slides[activeSlide].setAttribute('aria-live', 'polite');
            linkCarousel.update({
                startAt: parseInt(slides[activeSlide].dataset.slideId)
            });
        } else if ((Math.abs(slides[i].offsetTop - scrollTop) <= slideHeight) && !activeSlide) {
            slides[i].classList.add('active');
            linkCarousel.update({
                startAt: slides[i].dataset.slideId
            });
        }
    }
}

var glideFunction = {
    sameClassMultiCarousel: function (className, config) {
        var sliders = document.querySelectorAll(className);
        if (sliders.length > 0) {
            for (var i = 0; i < sliders.length; i++) {
                var glide = new Glide(sliders[i], config);
                this.checkGlideDisableLength(glide);
                this.glideArrowControll(glide, sliders[i]);
                this.removeExtraBullets(glide, sliders[i]);
                glide.mount({
                    createSlideLength
                });
            }
        }
    },

    carouselInit: function (className, config) {
        var glide = new Glide(className, config);
        this.glideArrowControll(glide, document.querySelector(className));
        return glide;
    },

    syncGlide: function (master, slave) {
        master.on('run', function (e) {
            if (e.steps === 0 && e.direction !== '=') {
                slave.go(e.direction);
                if (slave.settings.bound) {
                    var slideLength = $(slave.selector + ' .glide__slide').length;
                    if ((slideLength - slave.settings.perView) < master.index) {
                        slave.update({
                            startAt: master.index,
                            focusAt: (slave.settings.perView - (slideLength - (parseInt(master.index))))
                        });
                    } else {
                        slave.update({
                            startAt: master.index,
                            focusAt: 0
                        });
                    }
                }
            }
        });
    },

    thumbCarousel: function (carousel1, carousel2) {
        this.syncGlide(carousel1, carousel2);
        this.syncGlide(carousel2, carousel1);
    },

    clickGlide: function (className, mainSlide, thumbSlide) {
        var slideLength = $(thumbSlide.selector + ' .glide__slide').length;
        $(className + ' .glide-click').click(function (event) {
            var val = event.target.dataset.count;
            if (!mainSlide.disabled && !thumbSlide.disabled) {
                mainSlide.go('=' + val);
                thumbSlide.go('=' + val);
                if (thumbSlide.settings.bound) {
                    if ((slideLength - thumbSlide.settings.perView) < parseInt(val)) {
                        thumbSlide.update({
                            startAt: val,
                            focusAt: (thumbSlide.settings.perView - (slideLength - (parseInt(val))))
                        });
                    } else {
                        thumbSlide.update({
                            startAt: val,
                            focusAt: 0
                        });
                    }
                }
            }
        });
    },

    checkGlideMounted: function (className) {
        var checkClassName = $(className);
        if (checkClassName.hasClass('glide--ltr') || checkClassName.hasClass('glide--carousel') || checkClassName.hasClass('glide--swipeable')) {
            return true;
        }
        return false;
    },

    initGlideByElement(element, config) {
        return new Glide(element, config).mount();
    },

    camelbakPDCarouselSameClassInit: function (className, config) {
        var sliders = document.querySelectorAll(className);
        for (var i = 0; i < sliders.length; i++) {
            var glide = new Glide(sliders[i], config);
            $('#' + sliders[i].id + ' .arrows').removeClass('d-none');
            this.getSlideLength(glide, sliders[i]);
            this.camelbakSetUpdatedSlideValue(glide, sliders[i]);
            this.glideArrowControll(glide, sliders[i]);
            glide.mount({
                createSlideLength
            });
        }
    },

    getSlideLength: function (glide, currentSlide) {
        glide.on('slider.length', (length) => {
            currentSlide.querySelector('.glide-pageinfo').setAttribute('data-slidecount', length);
        });
    },

    camelbakSetUpdatedSlideValue: function (glide, currentSlide) {
        glide.on(['mount.after', 'run'], () => {
            const currentIndex = glide.index + 1;
            var currentDiv = currentSlide.querySelector('.glide-pageinfo');
            var length = currentIndex + '/' + currentDiv.getAttribute('data-slidecount');
            $(currentDiv).html(length);
        });
    },

    getDynamicBullets: function (className, config, wrapperClassName, isArrow) {
        var sliders = document.querySelectorAll(className);
        for (var i = 0; i < sliders.length; i++) {
            var glide = new Glide(sliders[i], config);
            this.getBulletsCount(glide, sliders[i], wrapperClassName, isArrow);
            glide.mount({
                createSlideLength
            });
            setAriaAttributes(glide);
        }
    },
    getBulletsCount: function (glide, currentSlide, wrapperClassName, isArrow) {
        if (isArrow) {
            glide.on('slider.length', (length) => {
                var bulletDiv = currentSlide.querySelector(wrapperClassName);
                bulletDiv.setAttribute('data-glide-el', 'controls');
                if (length > 1) {
                    var buttonDiv = '';
                    for (let index = 0; index < length; index++) {
                        buttonDiv += '<button class="glide_bullet" data-glide-dir="=' + index + '"></button>';
                    }
                    var html = '<div class="glide__arrow--left" data-glide-dir="<"></div>' +
                    '<div class="glide__bullets" data-glide-el="controls[nav]">' + buttonDiv +
                    '</div>' +
                    '<div class="glide__arrow--right" data-glide-dir=">"></div>' +
                    '</div>';
                    bulletDiv.innerHTML = html;
                    glide.destroy();
                    glide.mount();
                }
            });
        } else {
            glide.on('slider.length', (length) => {
                var bulletDiv = currentSlide.querySelector(wrapperClassName);
                if (length > 1) {
                    var buttonDiv = '';
                    for (let index = 0; index < length; index++) {
                        buttonDiv += '<button class="glide_bullet" data-glide-dir="=' + index + '"></button>';
                    }
                    var html =
                    '<div class="glide__bullets" data-glide-el="controls[nav]">' + buttonDiv +
                    '</div>' +
                    '</div>';
                    bulletDiv.innerHTML = html;
                    glide.destroy();
                    glide.mount();
                }
            });
        }
    },
    getGlideSlideLength: createSlideLength,
    checkGlideDisableLength: function (glide) {
        glide.on('slider.length', (length) => {
            if (length <= glide.settings.perView) {
                glide.update({
                    type: 'slider',
                    rewind: false
                });
                if ($(glide.selector).find('.glide__arrow--left').length && $(glide.selector).find('.glide__arrow--right').length) {
                    $(glide.selector).find('.glide__arrow--left').addClass('d-none');
                    $(glide.selector).find('.glide__arrow--right').addClass('d-none');
                    $(glide.selector).find('.glide__bullets').addClass('d-none');
                }
            }
        });
    },
    glideArrowControll: function (glide, currentSlider) {
        const slide = $(currentSlider);
        var length;
        if (slide.find('.glide__arrow--left').length && slide.find('.glide__arrow--right').length) {
            const glideArrowLeft = slide.find('.glide__arrow--left');
            const glideArrowRight = slide.find('.glide__arrow--right');
            glideArrowLeft.on('click', function () {
                glide.go('<');
            });
            glideArrowRight.on('click', function () {
                glide.go('>');
            });
            if (glide.settings.bound && !glide.settings.rewind) {
                Object.keys(glide.settings.breakpoints).forEach((e)=> {
                    if (window.matchMedia('(max-width: ' + e + 'px)').matches && glide.settings.breakpoints[e].perView) {
                        length = glide.settings.breakpoints[e].perView;
                        return;
                    // eslint-disable-next-line no-else-return
                    } else {
                        length = glide.settings.perView;
                    }
                });
                glide.on('mount.after', function () {
                    if (glide.index === 0) {
                        glideArrowLeft.addClass('glide__arrow--disabled');
                    }
                });
                glide.on('run.after', function () {
                    if (glide.index === 0 && !glideArrowLeft.hasClass('glide__arrow--disabled')) {
                        glideArrowLeft.addClass('glide__arrow--disabled');
                    } else if (glide.index !== 0 && glideArrowLeft.hasClass('glide__arrow--disabled')) {
                        glideArrowLeft.removeClass('glide__arrow--disabled');
                    }

                    if ((glide.index === (currentSlider.querySelectorAll('.glide__slide').length) - length) && !glideArrowRight.hasClass('glide__arrow--disabled')) {
                        glideArrowRight.addClass('glide__arrow--disabled');
                    } else if ((glide.index !== (currentSlider.querySelectorAll('.glide__slide').length) - length) && glideArrowRight.hasClass('glide__arrow--disabled')) {
                        glideArrowRight.removeClass('glide__arrow--disabled');
                    }
                });
            } else if (!glide.settings.rewind) {
                glide.on('mount.after', function () {
                    if (glide.index === 0) {
                        glideArrowLeft.addClass('glide__arrow--disabled');
                    }
                });
                glide.on('run.after', function () {
                    if (glide.index === 0 && !glideArrowLeft.hasClass('glide__arrow--disabled')) {
                        glideArrowLeft.addClass('glide__arrow--disabled');
                    } else if (glide.index !== 0 && glideArrowLeft.hasClass('glide__arrow--disabled')) {
                        glideArrowLeft.removeClass('glide__arrow--disabled');
                    }

                    if ((glide.index === (currentSlider.querySelectorAll('.glide__slide').length) - 1) && !glideArrowRight.hasClass('glide__arrow--disabled')) {
                        glideArrowRight.addClass('glide__arrow--disabled');
                    } else if ((glide.index !== (currentSlider.querySelectorAll('.glide__slide').length) - 1) && glideArrowRight.hasClass('glide__arrow--disabled')) {
                        glideArrowRight.removeClass('glide__arrow--disabled');
                    }
                });
            }
        }
    },
    verticalCarousel: function (container, linkCarousel) {
        if (container) {
            var galleryScroller = container.querySelector('.vertical-slides');
            var galleryItemSize = galleryScroller.querySelector('.slides-item').clientHeight;
            var prev = container.querySelector('.btn.prev');
            var next = container.querySelector('.btn.next');
            prev.addEventListener('click', () => scrollToPrevPage(galleryScroller, galleryItemSize));
            next.addEventListener('click', () => scrollToNextPage(galleryScroller, galleryItemSize));
            if (container.querySelectorAll('.slides-item').length > 5) {
                prev.classList.remove('d-none');
                next.classList.remove('d-none');
            }
            galleryScroller.addEventListener('scroll', function () {
                var el = this;
                setActive(el, linkCarousel);
            });
            if (galleryScroller.dataset.sliderBind && linkCarousel) {
                linkCarousel.on('run.after', function () {
                    setActive(galleryScroller, linkCarousel, linkCarousel.index);
                });
                var allSlides = galleryScroller.querySelectorAll('.slides-item');
                allSlides.forEach(item => item.addEventListener('click', function () {
                    linkCarousel.update({
                        startAt: this.dataset.slideId
                    });
                    var i = Array.prototype.indexOf.call(galleryScroller.children, this);
                    setActive(galleryScroller, linkCarousel, i);
                }));
            }
        }
    },
    removeExtraBullets: function (glide, currentSlide) {
        if (!($(currentSlide).hasClass('glide--ltr') || $(currentSlide).hasClass('glide--carousel') || $(currentSlide).hasClass('glide--swipeable'))) {
            var length;
            Object.keys(glide.settings.breakpoints).forEach((e)=> {
                if (window.matchMedia('(max-width: ' + e + 'px)').matches && glide.settings.breakpoints[e].perView) {
                    length = glide.settings.breakpoints[e].perView;
                    return;
                // eslint-disable-next-line no-else-return
                } else {
                    length = glide.settings.perView;
                }
            });
            if (glide.settings.bound && !glide.settings.rewind) {
                var bullets = currentSlide.querySelector('.glide__bullets');
                if ($(bullets).children().length > length) {
                    for (var i = 1; i < (length); i++) {
                        $(bullets.children).last().remove();
                    }
                }
            }
        }
    }
};

module.exports = glideFunction;
